module.exports = __webpack_public_path__ + "static/img/change_pwd.15bf81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gaoBaoBan/change_pwd.png
// module id = KGMq
// module chunks = 39